// import journals from '@/assets/data/special-projects/journal'

// const lastJournal = {
//   ...journals.gallery[0],
//   link: '/ideology_of_future',
// }

export default [
  {
    model_type: 'specialproject',
    slug: 'https://dostoevsky-club.ru/product/%D0%BA%D0%BE%D0%BC%D0%BF%D0%BB%D0%B5%D0%BA%D1%82-%D1%81%D0%BE%D0%B1%D0%B8%D1%80%D0%B0%D1%82%D0%B5%D0%BB%D0%B8-%D0%B7%D0%B5%D0%BC%D0%BB%D0%B8-%D1%80%D1%83%D1%81%D1%81%D0%BA%D0%BE%D0%B9-28-%D0%B8',
    image: {
      preview: '/projects/special/forager.jpg',
    },
    title: 'Собиратели Земли Русской',
    announce: '',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: 'https://dostoevsky-club.ru/product/%D0%BC%D0%B5%D0%B4%D0%B8%D0%BD%D1%81%D0%BA%D0%B8%D0%B9-%D0%B2-%D1%80-%D1%80%D0%B0%D1%81%D1%81%D0%BA%D0%B0%D0%B7%D1%8B-%D0%B8%D0%B7-%D1%80%D1%83%D1%81%D1%81%D0%BA%D0%BE%D0%B9-%D0%B8%D1%81%D1%82%D0%BE-3',
    image: {
      preview: '/projects/other/generals.jpeg',
    },
    title: '',
    announce: '',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: 'https://rvio.ru/storage/media/o_russkoj_smekalke_na_vojne.pdf',
    image: {
      preview: '/projects/special/russkoj_smekalke.jpg',
    },
    title: 'О русской смекалке на войне',
    announce:
      'Немецкая брошюра "Русские подручные средства и находчивость" (1944 г.) с научным комментарием',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/uncle_lenya.pdf',
    image: {
      preview: '/projects/special/uncle_lenya.jpg',
    },
    title: 'Рассказ в стихах «Дядя Лёня» о детях войны',
    announce: '',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/ukrainskie_pytki_rossijskih_voennosluzhashchih_doklad_web_versiya.pdf',
    image: {
      preview: '/projects/special/ukrainskie_pytki_pr.png',
    },
    title: '',
    announce:
      'Доклад Международного общественного трибунала по преступлениям украинских неонацистов (18+)',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/pritkins-essays.pdf',
    image: {
      preview: '/projects/special/pritkins-essays.jpg',
    },
    title: 'Вячеслав Прытков. Очерки из сборника',
    announce: '',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/chernaya_kniga_kratkaya_istoriya_shvedskoj_i_finskoj_rusofobii_na.pdf',
    image: {
      preview: '/projects/special/musta_kirja.png',
    },
    title: 'MUSTA KIRJA',
    announce: 'Suomalaisen Ja Ruotsalaisen Russofobian Lyhyt Historia',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/Chernaya_kniga_Metodicheskie_materialy_po_istorii_ukrainskogo_voprosa.pdf',
    image: {
      preview: '/projects/other/hist_ua_que.jpg',
    },
    title: 'Методические материалы по истории «украинского вопроса»',
    announce:
      'История «украинского вопроса» от эпохи Средневековья до настоящего времени',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/Chernaya_Kniga_Kratkaya_istoriya_polskoj_rusofobii_XX_XXI_vv_.pdf',
    image: {
      preview: '/projects/other/bl_pl_rf.jpg',
    },
    title: 'Краткая история польской русофобии. XX-XXI вв.',
    announce: 'Исследование об исторических корнях русофобии в Польше',
    isBlank: true,
  },
  // {
  //   model_type: 'specialproject',
  //   slug: '/female-heroes',
  //   image: {
  //     preview: require('~/static/projects/special/women-heroes.png'),
  //   },
  //   title: 'Женщины-герои',
  //   announce:
  //     'Проект посвящен женщинам, чьи поступки могут служить примером всем нам.',
  // },
  {
    model_type: 'specialproject',
    slug: '/files/black_book_1941-1945-en.pdf',
    image: {
      preview: '/projects/other/black_book_en.jpg',
    },
    title: 'The Black Book',
    announce: 'Atrocities and massacres committed by Banderaites (18+)',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: 'https://vk.cc/cp1kko',
    image: {
      preview: '/projects/other/black_book.jpg',
    },
    title: 'Черная книга',
    announce: 'Зверства бандеровцев 1941-1945 (18+)',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: 'https://vk.cc/cp1kP1',
    image: {
      preview: '/projects/other/black_book_2014-2023.jpeg',
    },
    title: 'Черная книга',
    announce:
      'Зверства современных бандеровцев - украинских неонацистов 2014-2023 (18+)',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/chk_ukrainian_books.pdf',
    image: {
      preview: '/projects/other/black_book-3-uk.jpg',
    },
    title: 'Черная книга',
    announce:
      'Украина – не Россия? Украинские школьные учебники XXI века: методы и механизмы фальсификации истории',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/chk_swedish_finnish.pdf',
    image: {
      preview: '/projects/other/black_book-4-fin.jpg',
    },
    title: 'Черная книга',
    announce: 'Краткая история шведской и финской русофобии',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/black-book-english.pdf',
    image: {
      preview: '/projects/other/bl-book-sw-rs.jpg',
    },
    title: 'The Black Book',
    announce: 'The History of Finnish and Swedish Russophobia',
    isBlank: true,
  },
  {
    model_type: 'specialproject',
    slug: '/files/chernaya-kniga-istoriya-pribaltijskoj-rusofobii.pdf',
    image: {
      preview: '/projects/other/bl_b_balt_v.png',
    },
    title: 'Черная книга История прибалтийской русофобии',
    announce: '',
    isBlank: true,
  },
];
